import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MibButtonDirective, MibIconComponent, MibModalComponent } from '@medinbox/angular';

export enum PiiDetectionChoice {
  Cancel = 'cancel',
  Review = 'review',
  Publish = 'publish',
}

@Component({
  selector: 'mai-pii-detected-dialog',
  imports: [MibModalComponent, MibButtonDirective, MibIconComponent],
  templateUrl: './pii-detected-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PiiDetectedDialog {
  readonly dialogRef = inject(DialogRef<PiiDetectionChoice>);

  readonly PiiDetectionChoice = PiiDetectionChoice;
}
